module.exports = function() {
  return new Worker(__webpack_public_path__ + "96d71dfb4f788e4a1f9f.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/components/common/AssetGalleryV2/Workers/fb.worker.js
// module id = 1965
// module chunks = 0